import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";

const DeleteModal = ({ show, handleClose, delFunc, title = "" }) => {
  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName="my-modal-content col-5 mx-auto ps-sm-5 fn_Nunito"
      contentClassName="my-modal-content"
    >
      <ModalBody>
        <div className="p-2">
          <p className="fn_Nunito fw_700 fs_18 color_262c3d my-2 px-0">
            Are you sure ?
          </p>
          <p className="fn_Nunito fw_400 fs_14 color_747f9e my-2 px-0">
            Do you want to delete this {title}
          </p>
          <div className="d-flex justify-content-between mt-4">
            <AdminButton
              width="150px"
              color="white"
              border="1px solid #FF6F5B"
              background="#FF6F5B"
              onClick={() => delFunc()}
            >
              <span className="m-2">DELETE</span>
            </AdminButton>
            <AdminButton
              width="150px"
              background="#7065e4"
              color="white"
              onClick={() => handleClose()}
            >
              <span className="m-2">NO</span>
            </AdminButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
